
















































import { Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store/'

@Component({
  props: {},
  components: {}
})
export default class Alerts extends Vue {
  // computed
  get state() {
    return vxm.alerts.alertState
  }

  // method
  dismissAlert() {
    vxm.alerts.setAlert(null)
  }
  countDownChanged(dismissCountDown: number) {
    vxm.alerts.countDownAlert(dismissCountDown)
  }
  // Lifecycle hooks
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
